var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWaitCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8371 9.9878C17.5885 9.57698 19.4112 9.57698 21.1625 9.9878C23.6918 10.5811 25.6666 12.5559 26.2599 15.0851C26.6707 16.8365 26.6707 18.6592 26.2599 20.4106C25.6666 22.9398 23.6918 24.9147 21.1625 25.5079C19.4112 25.9188 17.5885 25.9188 15.8371 25.5079C13.3079 24.9147 11.333 22.9398 10.7398 20.4106C10.3289 18.6592 10.3289 16.8365 10.7398 15.0851C11.333 12.5559 13.3079 10.5811 15.8371 9.9878ZM18.7471 15.1733C18.7471 14.8763 18.5063 14.6354 18.2092 14.6354C17.9121 14.6354 17.6713 14.8763 17.6713 15.1733V18.3433C17.6713 18.5272 17.7653 18.6984 17.9205 18.7971L20.3565 20.3471C20.6071 20.5066 20.9395 20.4327 21.099 20.182C21.2585 19.9314 21.1846 19.5989 20.9339 19.4395L18.7471 18.048V15.1733Z",
    fill: "#FF6321"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaitCircle);
export default __webpack_public_path__ + "static/media/icon-wait-circle.c4816e38ef66336e69270842c35eeded.svg";
export { ForwardRef as ReactComponent };